export const enumPermisosCerolioOAT = Object.freeze({
  cerolioOAT: 257,
});
